@if (isContentEditable) {
  @if (animationType == 1) {
    <div>
      <div>
        @switch (animationDirection) {
          @case (1) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@bounceIn]="animationState">
            </div>
          }
          @case (2) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@bounceInDown]="animationState">
            </div>
          }
          @case (3) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@bounceInLeft]="animationState">
            </div>
          }
          @case (4) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@bounceInRight]="animationState">
            </div>
          }
          @case (5) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@bounceInUp]="animationState">
            </div>
          }
          @default {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              >
            </div>
          }
        }
      </div>
    </div>
  }
  @if (animationType == 2) {
    <div>
      <div>
        @switch (animationDirection) {
          @case (1) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeIn]="animationState">
            </div>
          }
          @case (2) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeInDown]="animationState">
            </div>
          }
          @case (3) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeInLeft]="animationState">
            </div>
          }
          @case (4) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeInRight]="animationState">
            </div>
          }
          @case (5) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeInUp]="animationState">
            </div>
          }
          @default {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              >
            </div>
          }
        }
      </div>
    </div>
  }
  @if (animationType == 3) {
    <div>
      <div>
        @switch (animationDirection) {
          @case (2) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeInDownBig]="animationState">
            </div>
          }
          @case (3) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeInLeftBig]="animationState">
            </div>
          }
          @case (4) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeInRightBig]="animationState">
            </div>
          }
          @case (5) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@fadeInUpBig]="animationState">
            </div>
          }
          @default {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              >
            </div>
          }
        }
      </div>
    </div>
  }
  @if (animationType == 4) {
    <div>
      <div>
        @switch (animationDirection) {
          @case (1) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@zoomIn]="animationState">
            </div>
          }
          @default {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              >
            </div>
          }
        }
      </div>
    </div>
  }
  @if (animationType == 5) {
    <div>
      <div>
        @switch (animationDirection) {
          @case (4) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@flipInX]="animationState">
            </div>
          }
          @case (5) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@flipInY]="animationState">
            </div>
          }
          @default {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              >
            </div>
          }
        }
      </div>
    </div>
  }
  @if (animationType == 6) {
    <div>
      <div>
        @switch (animationDirection) {
          @case (1) {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              [@flash]="animationState">
            </div>
          }
          @default {
            <div id="contentblock-{{contentBlockId}}" [inlineMenuId]="'content-block-menu-' + contentBlockId"
              [innerHTML]="basicTextContent | safe:'html'" class="content-style content-block-content" appCKEditor
              [customConfig]="false" (ckFocus)="textClick($event)" (ckBlur)="textOnBlur($event)" contenteditable="true"
              >
            </div>
          }
        }
      </div>
    </div>
  }
  @if (!animationType) {
    <div id="contentblock-{{contentBlockId}}"
      [inlineMenuId]="'content-block-menu-' + contentBlockId" [innerHTML]="basicTextContent | safe:'html'"
      class="content-style content-block-content" appCKEditor [customConfig]="false" (ckFocus)="textClick($event)"
      (ckBlur)="textOnBlur($event)" contenteditable="true">
    </div>
  }
} @else {
  <div id="contentblock-{{contentBlockId}}" [innerHTML]="basicTextContent | safe:'html'"
    class="content-style content-block-content">
  </div>
}
